<template>
    <v-flex>
        <v-layout align-center column>
            <v-flex align-center style="margin-bottom: 56px; width: 100%;">
                <v-flex xs12 sm6 lg4 style="margin: auto;">
                    <div class="full-height">
                        <slot />
                    </div>
                    <div class="footer-nav">
                        <a href="#" @click.prevent="confirm_logout = true">Logout</a>
                        <span class="app-version">v{{ appVersion }}</span>
                        <!--<router-link v-if="['/my-data', '/nutrition'].indexOf($router.currentRoute.path) > -1" :to="'/messages' + getCurrentRoute()" class="help-btn"><v-icon>help</v-icon></router-link>-->
                        <router-link to="/privacy">Privacy</router-link>
                    </div>
                    <v-bottom-navigation
                            fixed
                            :value="true"
                    >
                        <div class="flex xs12 sm6 lg4" style="display: flex; justify-content: space-between; margin: 0 auto;">
                            <v-btn
                                    v-for="link in links"
                                    :key="link.link"

                                    text
                                    rounded
                                    :to="link.link"
                                    :active="true"
                            >
                                <span class="caption">{{ link.label }}</span>
                                <v-icon>{{ link.icon }}</v-icon>
                            </v-btn>
                        </div>
                    </v-bottom-navigation>
                </v-flex>
            </v-flex>
        </v-layout>
        <v-dialog
                v-model="confirm_logout"
                max-width="290"
                persistent
        >
            <v-card>
                <v-card-title class="headline">Logout</v-card-title>

                <v-card-text>
                    Are you sure you want to logout?
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn
                            color="primary lighten-1"
                            text
                            @click="confirm_logout = false"
                    >
                        No
                    </v-btn>

                    <v-btn
                            color="primary lighten-1"
                            text
                            @click="logout"
                    >
                        Yes
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
                v-if="snackbar"
                :timeout="0"
                v-model="snackbar"
                :color="snackbar.colour"
                top
                :multi-line="true"
        >
            <div v-html="snackbar.text"></div>
            <v-btn
                    dark
                    text
                    @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>

    </v-flex>
</template>

<script>

    import { mapState } from 'vuex'
    import { mapGetters } from 'vuex'

    import moment from 'moment'

    export default {
        name: 'default-layout',
        created () {
            /*
            this.snackbar = {
                text: 'Hola, I am <b>snack</b>!',
                colour: 'dark',
                nag: 60
            }
            */
        },
        data () {
            return {
                confirm_logout: false,
                links: [
                    {label: 'HOME', icon: 'home', link: '/'},
                    {label: 'MY DATA', icon: 'bar_chart', link: '/my-data/scan'},
                    {label: 'NUTRITION', icon: 'restaurant', link: '/nutrition'},
                    {label: 'ADVICE', icon: 'fitness_center', link: '/advice'}
                ]
            }
        },
        methods: {
            logout () {
                this.$store.dispatch('auth/logout')
            },
            getCurrentRoute () {
                let path = '/' + this.$router.currentRoute.path.split('/')[1]
                if(!path || path.length < 1) path = '/'
                return path
            }
        },
        computed: {
            todaysDay () {
                return moment().add(23-21, 'days').calendar(moment(), {
                    sameDay: '[Today]',
                    nextDay: '[Tomorrow]',
                    nextWeek: 'dddd',
                    lastDay: '[Yesterday]',
                    lastWeek: 'dddd',
                    sameElse: 'DD/MM/YYYY'
                })
            },
            ...mapState({
                challenge: state => state.challenge.challenge
            }),
            ...mapGetters({
                challengeWeeks: 'challenge/weeks',
                currentWeek: 'challenge/currentWeek',
                currentDay: 'challenge/currentDay',
                appVersion: 'auth/appVersion'
            }),
            snackbar: {
                get () {
                    return this.$store.state.global.snackbar
                },
                set (value) {
                    this.$store.dispatch('global/setSnackbar', value)
                }
            }
        }
    }
</script>

<style lang="scss">
    .footer-nav {
        width: 100%;
        background: #e0dcdc;
        margin-top: 0;
        display: flex;
        justify-content: space-between;
        padding: 10px 50px;
        a {
            text-transform: uppercase;
        }
    }

    .v-item-group.v-bottom-navigation--fixed {
        z-index: 9992 !important;
    }

    .v-item-group.v-bottom-navigation {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: auto;
        a {
            margin-top: 0;
            width: 25%;
        }
    }

    .v-snack {
        z-index: 9999 !important;
    }

    .help-btn {
        text-decoration: none;
        i {
            color: #24ADBB !important;
        }
    }

    .app-version {
        color: #666;
    }
</style>
